import styled from 'styled-components';
import { Box } from '@mui/material';

export const ApprovalWrapper = styled(Box)`
border:1px solid #1B4A83;
border-radius:5px;
  thead{
     background-color: #1B4A83;
     tr{
      
         th{
             color: #fff;
             font-weight: 600;
             height:30px;
             font-family: 'Noto Sans', sans-serif;
         }
     }
  }
  tbody{
    tr{
      td
      {
        height:30px;
        font-family: 'Noto Sans', sans-serif;
         }
     }
  }
    .custom-check-icon {
    color: #239155; 
    font-size: 16px;
      padding-right: 6px;
  }

  .custom-cancel-icon {
    color: #239155;
    font-size:16px;
      padding-right: 6px;
  }
  .custom-close-icon{
      color: #900916;
      font-size: 16px;
      padding-right: 6px;
  }

`;